// @ts-nocheck
const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  variantOptionsSortingChanged: 'variant-options-sorting-changed',
  variantChanged: 'variant-changed',
  variantStyleChanged: 'variant-style-changed',
  variantIdChanged: 'variant-id-changed',
  canvasImageUploaded: 'canvas-image-uploaded',
  canvasImageClear: 'canvas-image-clear',
  clearUploadedFile: 'clearup-uploaded-file',
  uploadCanvasReview: 'upload-canvas-review',
  borderMatChanged: 'border-mat-changed',
  changedGalleryImage: 'changed-gallery-image'
};

let PUB_SUB_ORIENTATION = [];
let PUB_SUB_CANVAS = [];
let PUB_SUB_BORDER_OPTIONS = [];